var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-widget__item"},[_c('div',{staticClass:"kt-widget__icon"},[_vm._t("icon")],2),_c('div',{staticClass:"kt-widget__details"},[_vm._t("detail")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }